const FETCH_STATUS = {
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
  IDLE: 'IDLE',
  LOADING: 'LOADING',
};

export default FETCH_STATUS;
